import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import SubmitButton from '../SubmitButton';
import { InviteParticipantStoreActions } from '../RenderInviteParticipantsModal';

export interface Props {
  actions: Pick<InviteParticipantStoreActions, 'back' | 'submit'>;
}

function Submit({ actions }: Props) {
  return (
    <div className="flex mt-16">
      <div
        className={clsx(
          'cursor-pointer rounded-md bg-white text-teal-600 border-teal-600 px-3 py-2 text-sm',
          ' w-24 text-center mt-4 border mr-4',
        )}
        onClick={actions.back}
      >
        <T kind="Back" />
      </div>
      <SubmitButton onClick={actions.submit} buttonText={'Submit'} />
    </div>
  );
}

export default observer(Submit);
